import React, {useEffect, useState} from 'react'
import {connect} from "react-redux";
import {adminHttp} from "~/Admin/services/http";
import ValidationError from "~/Components/Forms/ValidationError";
import ConfirmedButton from "~/Components/ConfirmedButton/ConfirmedButton";
import moment from "moment";
import DatePicker from "~/Components/DatePicker/DatePicker";
import Translated from "~/Admin/AdminMultilang/Translated";

const AdminEventScheduleItem = ({match, event, schedule, onChange, onDelete, ...props}) => {

    const defaultForm = {
        name: schedule?.name || '',
        date: moment(schedule?.date),
        description: schedule?.description || '',
        duration: schedule?.duration || 0,
        category: schedule?.category || '',
        translations: schedule?.translations || {}
    };

    const [form, setForm] = useState(defaultForm);

    const [error, setError] = useState(null);
    const [message, setMessage] = useState('');

    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        setForm({...form, [name]: value});
    };

    const handleDelete = () => {
        adminHttp
            .delete('/events/' + event.id + '/schedules/' + schedule.id)
            .then(res => {
                setError(null);
                setMessage('');

                if (onDelete) {
                    onDelete();
                }

            }).catch((error) => {
            setMessage(null);
            setError(error.response?.data);
        });
    }

    const handleSubmit = () => {
        adminHttp
            .put('/events/' + event.id + '/schedules/' + schedule.id, form)
            .then(res => {
                setError(null);
                setMessage('Saved successfully!');

                if (onChange) {
                    onChange();
                }

            }).catch((error) => {
            setMessage(null);
            setError(error.response?.data);
        });
    };

    const handleDateChange = (name, value) => {
        setForm({...form, [name]: value});
    };

    return (
        <div>
            {message && (
                <div className="alert alert-success" role="alert">
                    {message}
                </div>
            )}

            {error && (
                <div className="alert alert-danger" role="alert">
                    {error.message || "Error saving event!"}
                </div>
            )}

            <div className="form-group required">
                <label className="d-block">Session Name</label>

                <Translated translations={form.translations}
                            onChanged={(values) => setForm({...form, translations: values})}>
                    <input
                        onChange={handleChange}
                        value={form.name}
                        name="name"
                        className="form-control"/>
                </Translated>

                <ValidationError errors={error?.errors} name="name"/>
            </div>

            <div className="form-group required">
                <label className="d-block">Session Category</label>

                <Translated translations={form.translations}
                            onChanged={(values) => setForm({...form, translations: values})}>
                    <input
                        onChange={handleChange}
                        value={form.category}
                        name="category"
                        className="form-control"/>
                </Translated>

                <ValidationError errors={error?.errors} name="category"/>
            </div>

            <div className="form-group required">
                <label>Session Date</label>

                <DatePicker
                    date={form.date}
                    onChange={(date) => handleDateChange('date', date)} />

                <ValidationError errors={error?.errors} name="date"/>
            </div>

            <div className="form-group required">
                <label className="d-block">Session Duration</label>
                <input
                    onChange={handleChange}
                    value={form.duration}
                    name="duration"
                    className="form-control"/>

                {/* <small>Session duration in <b>MINUTES</b></small> */}

                <ValidationError errors={error?.errors} name="duration"/>
            </div>

            <div className="form-group required">
                <label className="d-block">Description</label>

                <Translated translations={form.translations}
                            onChanged={(values) => setForm({...form, translations: values})}>
                    <textarea
                        onChange={handleChange}
                        value={form.description}
                        rows={10}
                        name="description"
                        className="form-control"/>
                </Translated>

                <ValidationError errors={error?.errors} name="description"/>
            </div>

            <button
                onClick={handleSubmit}
                className="btn btn-primary text-cta float-right btn-sm">
                Save Session
            </button>

            <ConfirmedButton
                onClick={handleDelete}
                className="btn btn-danger text-cta float-right mr-3 btn-sm">
                Delete Session
            </ConfirmedButton>

        </div>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminEventScheduleItem);
